export default {
  auth: () => import("/vercel/path0/layouts/auth.vue").then(m => m.default || m),
  dashboard: () => import("/vercel/path0/layouts/dashboard.vue").then(m => m.default || m)
}